module.exports = __webpack_public_path__ + "img/img25.ea06dd79.svg";